<div [formGroup]="lookupFormGroup">
    <div class="d-flex mb-4">
      <!-- Country -->
      <div class="add-org-input">
        <yc-typeahead-select 
          [label]="'common:labelLocation' | ycI18n: 'Location'"
          [items]="countrySelects"
          [disabled]="disableCountrySelect"
          [showClear]="false"
          name="country"
          (onChange)="updateAddOrg('country', $event)">
        </yc-typeahead-select>
      </div>
      <div class="add-org-input">
        <!-- Reg ID -->
        <yc-input
          [label]="'common:labelGovTaxIdentificationNumber' | ycI18n: 'Government tax identification number'"
          name="id"
          (onChange)="updateAddOrg('id', $event)">
        </yc-input>
        <small>
          <yc-i18n
            [key]="'search:textGovTaxNumberExamples'"
            defaultValue="Government tax identification number such as EIN, Tax ID, VAT, BN, or PAN">
          </yc-i18n>
        </small>
      </div>
    </div>
</div>